
import React from "react";
import { useMarginAnalysis } from "./margin-analysis/useMarginAnalysis";
import FilterHeader from "./margin-analysis/FilterHeader";
import MetricsSection from "./margin-analysis/MetricsSection";
import ProjectionsSection from "./margin-analysis/ProjectionsSection";
import ChartSection from "./margin-analysis/ChartSection";
import LeaderboardTable from "./margin-analysis/LeaderboardTable";
import { supabase } from "@/integrations/supabase/client";
import { useEffect, useState } from "react";
import { User } from "@supabase/supabase-js";

const MarginAnalysisTab = () => {
  const [state, actions] = useMarginAnalysis();
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const fetchUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setUser(user);
    };

    fetchUser();

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (session?.user) {
          setUser(session.user);
        } else {
          setUser(null);
        }
      }
    );

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return (
    <div className="space-y-2">
      {/* Filter header section */}
      <FilterHeader state={state} actions={actions} />
      
      {/* Main content grid */}
      <div className="grid grid-cols-5 gap-3">
        {/* Left column for metrics - 2 columns wide */}
        <div className="col-span-2 flex flex-col gap-3 my-0 py-0">
          {/* Current Gross Margin Section */}
          <MetricsSection state={state} />
          
          {/* Projections Section */}
          <ProjectionsSection state={state} actions={actions} />
        </div>

        {/* Right column for charts - 3 columns wide */}
        <ChartSection state={state} />
      </div>
      
      {/* Full width section for Leaderboard table */}
      <LeaderboardTable state={state} actions={actions} />
    </div>
  );
};

export default MarginAnalysisTab;
